module Meevo.Plugins.Services {
    "use strict";


    /**
    * Main Section of Services
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Service> {
        notificationsSection;
        public numberOfPriceLevelsToDisplay: any
        public serviceChargesTypeEnum: Model.ChargeTypeEnum;
        public selectedEquipment: Model.Equipment;
        public isEgiftEnabled: boolean;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey);

            this.getServicePriceLevels().then((result) => {
                this.setServicePriceLevels();
            });


            this.getEgiftSettings();
        }
        showSku(): boolean {
            //only for JCP
            return this.identityService.current().tenantId == 1;
        }
        
        getServicePriceLevels(): angular.IPromise<Meevo.Model.RegisterSettings> {
            return this.dataService.customMethodData('/api/Settings/Register', 'GET', null).then((response) => {
                this.numberOfPriceLevelsToDisplay = response.data.defaultPriceLevelsForService;
                return response;
            });
        }

        setServicePriceLevels(): void {
            if (_.isUndefined(this.model) || _.isUndefined(this.model.priceLevels)) return;

            let priceLevelsForService = angular.copy(this.model.priceLevels);
            if (!Array.isArray(priceLevelsForService)) return;

            let lastPriceLevelWithValue = _.findIndex(priceLevelsForService.reverse(), (pl: any) => pl.price && pl.price !== 0);
            let numberOfPriceLevelsWithValue = lastPriceLevelWithValue >= 0 ? this.model.priceLevels.length - lastPriceLevelWithValue : lastPriceLevelWithValue;
            this.numberOfPriceLevelsToDisplay = numberOfPriceLevelsWithValue > this.numberOfPriceLevelsToDisplay ? numberOfPriceLevelsWithValue : this.numberOfPriceLevelsToDisplay;
        }

        activate(): void {
            super.activate();
            if (Model.Guard.isSomething(this.model)) {
                this.setServicePriceLevels();
            }
        }

        showPriceLevel(index): boolean {
            let show = index < this.numberOfPriceLevelsToDisplay;
            return show;
        }

        addPriceLevel(): void {
            this.numberOfPriceLevelsToDisplay += 1;
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
                postAdd(this.model);
                this.setServicePriceLevels();
            })
        }

        createSectionModelCopy(): Model.Service {
            let item = <Model.Service>(this.model);
            item.id = null;
            return item;
        }

        get isNotBookable(): boolean {
            return this.model ? !this.model.isBookable : false;
        }

        set isNotBookable(val: boolean) {
            this.model.isBookable = !val;
        }

        isNotBookableChanged() {
            if (angular.isDefined(this.notificationsSection)) {
                this.notificationsSection.isVisible = this.model.isBookable;
            }
        }

        get isOwner(): boolean {
            return this.model.homeLocationId == this.model.locationId;
        }

        revertDepositEnabled() {
            this.model.isDepositEnabled = this.model.revertToValueIsDepositEnabled;
            if(this.isOwner)
                this.model.isDepositEnabled_T = null;
            else
                this.model.isDepositEnabled_L = null;
        }

        revertDepositAmount() {
            this.model.depositAmount = this.model.revertToValueDepositAmount;
            this.model.isDepositPercent = this.model.revertToValueIsDepositPercent;
            
            if(this.isOwner)
                this.model.depositAmount_T = this.model.isDepositPercent_T = null;
            else
                this.model.depositAmount_L = this.model.isDepositPercent_L = null;
        }

        overrideDepositAmount() {

            if (this.isOwner) {
                this.model.isDepositPercent_T = this.model.isDepositPercent;
                this.model.depositAmount_T = this.model.depositAmount;
            } else {
                this.model.isDepositPercent_L = this.model.isDepositPercent;
                this.model.depositAmount_L = this.model.depositAmount;
            }

        }

        overrideDepositEnabled() {

            if (this.isOwner) 
                this.model.isDepositEnabled_T = this.model.isDepositEnabled;
            else
                this.model.isDepositEnabled_L = this.model.isDepositEnabled;            
        }

        addEquipment(): void {
            this.model.addOnServiceEquipments = this.model.addOnServiceEquipments || []
            if (!!this.selectedEquipment) {
                const equipment: Model.EquipmentDataDetail = {
                    serviceId: this.model.id,
                    id: this.selectedEquipment.id,
                    quantity: 1
                }
                if (!this.model.addOnServiceEquipments.some(a => a.id === this.selectedEquipment.id)) {
                    this.model.addOnServiceEquipments.push({ ...this.selectedEquipment, ...equipment });
                }
                this.selectedEquipment = null;
            }
        }


        onChangedSubCat(): void {
            if (Model.Guard.isSomething(this.model)) {
                if (Model.Guard.isSomething(this.model.categoryDetail)) {
                    this.model.categoryDisplayId = "";
                }
            }

        }

        removeEquipment(equipment: Model.EquipmentDataDetail): void {
            const index = this.model.addOnServiceEquipments.findIndex(e => e.id === equipment.id);
            this.model.addOnServiceEquipments.splice(index, 1)
        }

        getEgiftSettings(): void {
            this.dataService.getItem(`eGift/settings`).then((eGiftSettings: Model.IEGiftsSettings) => {
                this.isEgiftEnabled = eGiftSettings.settings.enableNewEgiftExperience || eGiftSettings.settings.enableServicesCalculator;
            });
        }

        preSave(): void {
            if ((this.isOwner && this.model.isDepositEnabled_T == null) || (!this.isOwner && this.model.isDepositEnabled_L == null))
                this.model.isDepositEnabled = null;
            if ((this.isOwner && this.model.depositAmount_T == null) || (!this.isOwner && this.model.depositAmount_L == null)) {
                this.model.depositAmount = null;
                this.model.isDepositPercent = null;
            }
            if ((this.isOwner && this.model.isDepositPercent_T == null) || (!this.isOwner && this.model.isDepositPercent_L == null)) {
                this.model.depositAmount = null;
                this.model.isDepositPercent = null;
            }
            if (Model.Guard.isNothing(this.model.visitNoteTypeDetail)) {
                this.model["visitNoteTypeDisplayName"] = null;
                this.model["visitNoteTypeId"] = null;
            }
        }
    }

}